export enum AlarmBoundDirection {
  UPPER_BOUND = 'UPPER_BOUND',
  LOWER_BOUND = 'LOWER_BOUND',
}
